import { Routes } from '@angular/router';
import { APP_BASE_HREF } from '@angular/common';
import { AuthGuard } from './shared/guard/auth.guard';
// service config
var SERVICE_CONFIG = [
    {
        provide: APP_BASE_HREF,
        useValue: '/pharmacy/mdp-dashboard/'
    }
];
var ɵ0 = function () { return import("./dashboard/dashboard.module.ngfactory").then(function (m) { return m.DashboardModuleNgFactory; }); }, ɵ1 = function () { return import("./dashboard/select-user/select-user.module.ngfactory").then(function (m) { return m.SelectUserModuleNgFactory; }); }, ɵ2 = function () { return import("./logout/logout.module.ngfactory").then(function (m) { return m.LogoutModuleNgFactory; }); };
export var routes = [
    {
        path: '',
        loadChildren: ɵ0,
        canActivate: [AuthGuard]
    },
    {
        path: 'select-user',
        loadChildren: ɵ1
        // canActivate: [AuthGuard]
    },
    {
        path: 'logout',
        loadChildren: ɵ2
    },
    /*signin{
      path: 'signin', // DEV ONLY: MUST REMOVE BEFORE LIVE DEPLOYMENT AS SCAT IS USED
      loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
      canActivate: [ShouldAuthenticateGuard]
     },signin*/
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
    }
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1, ɵ2 };
